import {NetworkState, networkStateReducer, post, reset} from "../networkStateReducer";
import {Cart} from "./types";
import {useDispatch, useSelector} from "react-redux";
import {RootState} from "../index";

export const domain = "@appigo-retailer/cart/set/set-selected-currency"

export const cartSetSelectedCurrencyReducer = networkStateReducer<Cart>(domain)

export function useSetSelectedCurrency():[NetworkState<Cart>,(selectedCurrency: string) => void, () => void] {
    let dispatch = useDispatch()

    return [
        useSelector<RootState, NetworkState<Cart>>(state => state.cart.setSelectedCurrency),
        (selectedCurrency) => dispatch(post(domain, "/customer-api/v2/cart/set/selected-currency",{},{ query:{ selectedCurrency: selectedCurrency ? selectedCurrency : undefined }})),
        () => dispatch(reset(domain))
    ]

}